import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const DraftingCC = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Drafting Commercial Contracts here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, where precision and expertise converge to craft legally robust <span className="highlight">commercial contracts</span> tailored to meet the unique needs of our clients. We are proud to introduce our specialized Commercial Contract Drafting Services comprising of comprehensive and meticulous drafting services meticulously crafted to address the diverse requirements of our esteemed clientele. With an unwavering commitment to excellence and adherence to statutory mandates, our team navigates the intricacies of contract law with precision and efficacy.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, we recognize the critical importance of well-drafted commercial contracts in facilitating smooth business transactions and mitigating legal risks. Our practice is grounded in a steadfast dedication to upholding the highest standards of legal integrity, ensuring that our clients' contractual arrangements adhere to relevant legislation, including but not limited to:</p>
        <p>
        The Indian Contract Act, 1872: Governs the formation and enforcement of contracts, prescribing essential elements such as offer, acceptance, consideration, and lawful object.
        <br />
        <br />
        The Specific Relief Act, 1963: Provides remedies for breach of contract, including specific performance, injunctions, and damages, to ensure the enforcement of contractual obligations.
        <br />
        <br />
        The Competition Act, 2002: Regulates anti-competitive agreements and unfair trade practices, ensuring fair competition in the market and protecting consumer interests.</p>
        <br />
        <p>With a profound understanding of these statutes and their implications, our team collaborates closely with clients to draft commercial contracts that are <span className="highlight">legally sound</span>, <span className="highlight">commercially viable</span>, and aligned with their <span className="highlight">strategic objectives</span>. Whether it's negotiating <span className="highlight">complex business transactions</span>, <span className="highlight">drafting partnership agreements</span>, or <span className="highlight">structuring vendor contracts</span>, we offer tailored solutions designed to safeguard our clients' interests and optimize their commercial outcomes.</p>
        <br />
        <p>Please reach out to us at your earliest convenience to explore how our Commercial Contract Drafting Services at <span className="kwa">KWA </span>can aid you in proficiently maneuvring through the intricacies of contract law in India with assurance and effectiveness.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default DraftingCC
